const hexColors = {
  black: '#000000',
  white: '#FFFFFF',
  grey: {
    50: '#FAFAFA',
    100: '#F5F5F5',
    200: '#EEEEEE',
    300: '#E0E0E0',
    400: '#BDBDBD',
    500: '#9E9E9E',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    1000: '#141618'
  },
  semantic: {
    error: '#F51A5A',
    alert: '#FFB32B',
    active: '#0078FF',
    success: '#24b300'
  }
}

const initialColors = {
  brand: {
    core: hexColors.black,
    accent: hexColors.white
  },
  background: {
    primary: hexColors.black,
    secondary: hexColors.grey[800],
    tertiary: hexColors.grey[200],
    quaternary: hexColors.white
  },
  border: {
    primary: hexColors.black,
    secondary: hexColors.grey[500],
    tertiary: hexColors.grey[300],
    quaternary: hexColors.white
  },
  text: {
    primary: hexColors.black,
    secondary: hexColors.grey[700],
    tertiary: hexColors.grey[400],
    quaternary: hexColors.white
  },
  state: { ...hexColors.semantic }
}

export const colors = {
  ...initialColors
}

export type ThemeColors = keyof typeof colors

export type BackgroundColorTypes = `background.${keyof typeof colors.background}`
